/**
 * Map a React Router pathname to the route-name slug we record in
 * `page.viewed`. Strict whitelist by first path segment — `/customers/:id`
 * collapses to `'customers'` so we don't leak the customer UUID into
 * PostHog (per docs/tracking-plan.md §3 + §6 "Do not use capture_pageview").
 * Unknown paths get tagged `'unknown'` rather than echoed back.
 *
 * Extracted from src/App.tsx so both the tenant AppShell and the admin
 * AuthedLayout emit identical names. Existing names are a telemetry
 * contract (DESIGN.md §9) — never rename; only append.
 */
const PAGE_NAMES = new Set([
  'dashboard',
  'estimates',
  'appointments',
  'calls',
  'customers',
  'vehicles',
  'dealers',
  'suppliers',
  'messaging',
  'settings',
  'admin',
  'integrations',
  'sign-up',
  'more',
  'activity',
  // admin host
  'tenants',
  'usage',
  'audit',
])

export function pageNameFor(pathname: string, isAdminHost: boolean): string {
  if (pathname === '/' || pathname === '') {
    return isAdminHost ? 'admin_tenants' : 'dashboard'
  }
  const first = pathname.replace(/^\/+/, '').split('/')[0]
  return PAGE_NAMES.has(first) ? first : 'unknown'
}
